
export function formatAttributeName(attributeName){
  
    //Special Cases
    if (attributeName === "major_minor_virtual_channel_number") attributeName = "Major.Minor VCN"
    else if (attributeName === "bsid3_or_tsid1_verance_required_info") attributeName = "BSID3/TSID1"
    else if (attributeName === "website_vod_assets") attributeName = "Website"
    else if (attributeName === "wide_orbit_log_recieved_format") attributeName = "Wide Orbit Log Format"
    else if (attributeName === "host_or_non_host_for_atsc3") attributeName = "ATSC3 Host Status"
    else if (attributeName === "google_analytics_deployment_verified") attributeName = "Google Analytics Deployed"
    else if (attributeName === "affiliation") attributeName = 'Affiliate'
    else if (attributeName === "receiving_daily_WO_logs") attributeName = 'Receiving Daily WO Logs?'
  
    //General Cases
    else {
        attributeName = attributeName.replace(/_/g, ' ')
        attributeName = attributeName.replace(/atsc/g, 'ATSC')
        attributeName = attributeName.replace(/^dma /g, 'DMA ')
        attributeName = attributeName.replace(/ vp1 /g, ' VP1 ')
        attributeName = attributeName.replace(/^ba /g, 'BA ')
        attributeName = attributeName.replace(/ ba /g, ' BA ')
        attributeName = attributeName.replace(/ gsid$/g, ' GSID')
        attributeName = attributeName.replace(/ ip /g, ' IP ')
        attributeName = attributeName.replace(/ id$/g, ' ID')
        attributeName = attributeName.replace(/ uuid$/g, ' UUID')
        attributeName = attributeName.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
    }
  
    return attributeName 
}
